var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 13C10.9898 13 13.8999 10.0899 13.8999 6.5C13.8999 2.91015 10.9898 0 7.3999 0C3.81005 0 0.899902 2.91015 0.899902 6.5C0.899902 10.0899 3.81005 13 7.3999 13Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1643 6.50034C12.1643 6.81559 11.9985 7.09184 11.7548 7.25434L7.63375 10.5108C7.247 10.8196 6.6815 10.7513 6.376 10.3646C6.06725 9.97784 6.1355 9.41234 6.52225 9.10684L8.68025 7.39734H3.5355C3.03825 7.39734 2.63525 6.99759 2.63525 6.50034C2.63525 6.00309 3.03825 5.60009 3.5355 5.60009H8.6835L6.5255 3.89059C6.13875 3.58509 6.0705 3.02284 6.37925 2.63284C6.68475 2.24609 7.25025 2.17784 7.637 2.48659L11.7548 5.74634C11.9985 5.90884 12.1643 6.18509 12.1643 6.50034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.8254aafa71134e4276cdaa5e7350f7bf.svg";
export { ForwardRef as ReactComponent };